import React from 'react';
import { Home, TrendingUp, Key, ExternalLink } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { realEstateServices, socialLinks, realtorInfo } from '../mock';

const iconMap = {
  Home,
  TrendingUp,
  Key
};

const RealEstateServices = () => {
  return (
    <section id="real-estate" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Real Estate Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional real estate solutions for buying, selling, and managing rental properties
          </p>
        </div>

        {/* Image Banner */}
        <div className="mb-12 rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="https://customer-assets.emergentagent.com/job_gifted-beaver-1/artifacts/yqr4op3q_IMG_6979.jpeg" 
            alt="Cape Cod Real Estate"
            className="w-full h-64 object-cover"
          />
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {realEstateServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-gray-200 bg-white"
              >
                <CardHeader className="space-y-4">
                  <div className="w-14 h-14 bg-stone-100 rounded-xl flex items-center justify-center group-hover:bg-stone-700 transition-colors">
                    <IconComponent className="w-7 h-7 text-stone-700 group-hover:text-white transition-colors" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-stone-700 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* Realtor Profile Section */}
        <div className="bg-gradient-to-br from-amber-50 to-stone-50 rounded-2xl p-8 border border-amber-100">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Photo */}
            <div className="flex justify-center">
              <div className="relative">
                <img 
                  src={realtorInfo.photo} 
                  alt={realtorInfo.name}
                  className="w-64 h-64 rounded-2xl object-cover shadow-xl"
                />
              </div>
            </div>
            
            {/* Info */}
            <div className="text-center md:text-left">
              <h3 className="text-3xl font-bold text-gray-900 mb-2">
                {realtorInfo.name}
              </h3>
              <p className="text-lg text-amber-800 font-semibold mb-4">
                {realtorInfo.title}
              </p>
              <p className="text-gray-600 mb-6">
                For comprehensive real estate services, property listings, and expert guidance throughout the Cape area
              </p>
              <Button 
                onClick={() => window.open(socialLinks.realEstate.website, '_blank')}
                size="lg"
                className="bg-stone-700 hover:bg-stone-800 text-white transition-colors"
              >
                Visit My Real Estate Website
                <ExternalLink className="ml-2 w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RealEstateServices;
